export const DOMAIN = 'consentConfigDetails.configuration.iab';
